<template>
  <div>
    <TransitionWrapper name="slideVertical">
      <Select
        v-if="isCountryDataCenterRegion"
        v-model="user.dataCenter"
        :class="selectClass"
        data-test-id="DataCenterPicker__Select"
        :helperText="inputField.dataCenter.helperText"
        isFullWidth
        :label="inputField.dataCenter.label"
        large
        :name="inputField.dataCenter.name"
        :options="dataCenterOptions"
        rules="required"
        @blur="sendInputEnteredEvent(inputField.dataCenter)"
      />
    </TransitionWrapper>
  </div>
</template>

<script>
import {
  Select,
  TransitionWrapper,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import SignupConstants from 'client/util/Constants/SignupConstants';

const { dataCenterRegions } = SignupConstants;

export default {
  name: 'DataCenterPicker',

  components: {
    Select,
    TransitionWrapper,
  },

  props: {
    selectClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputField: {
        dataCenter: {
          helperText: 'Choose carefully, the selected region cannot be changed.',
          label: 'Primary Data Storage', // This is a generic label that is specifically used for the segment event.
          name: 'dataCenterRegion',
        },
      },
    };
  },

  computed: {
    ...mapState(['user']),

    dataCenterOptions() {
      const options = [];

      if (this.user.country) {
        Object.entries(dataCenterRegions).forEach(([region, { countries, label }]) => {
          if (countries.includes(this.user.country)) {
            options.push({ name: label, value: region });
          }
        });
      }

      // Always add the 'US Data Center' region as an option
      options.push({ name: 'United States', value: 'us' });

      return options;
    },

    isCountryDataCenterRegion() {
      return this.dataCenterOptions.some(option => option.value !== 'us');
    },
  },

  watch: {
    'user.country': function () {
      this.user.dataCenter = this.getDataCenterRegion(this.user.country);
    },

    'user.dataCenter': function (newVal) {
      this.setTargetEnv(newVal);
    },
  },

  methods: {
    ...mapActions([
      'sendInputEnteredEvent',
      'setTargetEnv',
    ]),

    getDataCenterRegion(country) {
      return Object.entries(dataCenterRegions).reduce(
        (acc, [region, { countries }]) => (countries.includes(country) ? region : acc),
        'us',
      );
    },
  },
};
</script>
